:host {
  display: block;
  max-width: 100%;
  height: 100%;
}

.wrapper {
  flex-direction: column;
}

gz-button[class="primary"] {
  margin-right: var(--spacer);
}
